<div *ngIf="allLoaded" class="container" [ngClass]="{'ionic': useIonic,  'selectedItem' : routeId > 0 }">
    <div class="cards list">

        <div class="search-pair">
            <input type="text" class="searchbox" placeholder="{{ 'SEARCH' | translate }}" [(ngModel)]="searchText" />
            <div class="searchbox-contadors">{{ filterMetadata.count }}/{{ routes.length }}</div>
        </div>

        <div class="page">
            <div class="column">
                <div class="llista" [ngClass]="{'selectedItem' : routeId > 0}">
                    <div class="overflow">
                        <shared-route-item-list
                            *ngFor="let item of routes | filterActiveRoutes:searchText:filterMetadata | orderbyroutecarddto:true; let i=index"
                            (click)="onClickItem(item)" (dblclick)="onDoubleClickItem(item)"
                            [selected]="selectedRoute && selectedRoute.routeId == item.routeId"
                            class="routeItem monochrome" [route]="item">
                        </shared-route-item-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <shared-active-bookings-item-route class="cards one" [bookingId]="bookingId" [routeId]="routeId"
        (onRouteChanged)="onRouteChanged($event, true)" (onRouteRefresh)="onRouteChanged($event, false)"
        (clickBack)="onClickBack($event)"></shared-active-bookings-item-route>
</div>